<template>
    <form id="login-page-form " @submit.prevent="submit">
        <div class='central login-background '>
            <div klass=" login-box  padding-xl_sd  padding-lr-xxl_sd fixed-full_sd_max  "
                 class="login-box padding-tb-xl padding-lr-l padding-xl_sd  padding-lr-xxl_sd"
            >
                <div id='main-col' class=" col gap align-items-center justify-center  text-l ">

                    <!-- <div class="hidden_sd padding-t-xxl"></div> -->
                    <div class="padding-tb-xl width-20rem  ">
                        <img class='login-image' src='/images/logo.png' alt='Park'>
                    </div>
                    <div class="lang-selector tabs tabs-compact primary  justify-center flex-wrap  text-m">
                        <button v-for="(langName,langCode) of langs" :key="langCode"
                                :class="{active:langCode==lang}"
                                @click="setLang(langCode)" type="button">{{ langName }}
                        </button>

                    </div>

                    <div class="padding-t-l  login-messages ">
                        <div v-if="isError" class='text-danger fx-shake font-size-5 '>{{ texts.errorLogin }}</div>
                        <div v-else class='fx-fade-in  font-300 font-size-3 '>{{ texts.title }}</div>
                    </div>


                    <div class='col gap-m align-items-start   text-left '>
                        <fieldset class='group-input width-18rem  width-20rem_sd '>
                            <label for="login-page-user" class="group-text icon" :title="texts.username">
                                <span class="ti-user" aria-hidden="true"></span>
                            </label>
                            <input
                                    v-model="username"
                                    @input="clearErrors"
                                    type="text"
                                    class=" input "
                                    id="login-page-user"
                                    required maxlength="100"
                                    autocomplete="username"
                                    :placeholder="texts.username"
                            >
                        </fieldset>
                        <fieldset class="group-input   width-18rem  width-20rem_sd  ">
                            <label for="login-password" class="group-text icon" :title="texts.password">
                                <span class="ti-lock" aria-hidden="true"></span>
                            </label>
                            <input
                                    v-model="password"
                                    @input="clearErrors"
                                    type='password'
                                    id='login-password'
                                    :placeholder="texts.password"
                                    class="input "
                                    maxlength="100" required
                                    autocomplete="current-password">
                        </fieldset>
                    </div>
                    <div>
                        <button type='submit' class="button primary">{{ texts.signIn }}</button>
                    </div>
                    <div class="padding-t-xl">
                        <a href="https://bankoi.biz" target="_blank">
                            <img class='login-bsf' src="../../assets/bankoi-software-factory-linea.svg"
                                 alt="bankoi software factory "></a>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script setup>
import app from '@/core/app/app';
import auth from '@/core/app/auth';
import cfg from '@/app/cfg';
import ui from '@/core/app/ui';
import tx, {txGetLoginTexts, txSetLang} from '@/core/app/tx';
import {ref} from 'vue';
import {useRouter} from 'vue-router';


const isError = ref(false);
const lang = ref(tx.getLangCode());
const langs = ref(cfg.langs);
const texts = ref(txGetLoginTexts(lang.value));
const username = ref('');
const password = ref('');
const router = useRouter();

const setLang = (langCode) => {
    txSetLang(langCode);
    lang.value = tx.getLangCode();
    texts.value = txGetLoginTexts();
}

const submit = async () => {
    await auth.logIn(username.value, password.value);
    if (auth.isLoggedIn()) {
        app.setLang(lang.value);
        router.push({name: "home"});
    } else isError.value = true;
}

const clearErrors = () => {
    isError.value = false;
}

ui.applyThemes('light', '14px');
</script>

<style>

body, html {
    height: 100%;
    margin: 0;
    padding: 0;
    background: hsl(0, 0%, 95%);
}


.login-image {
    max-height: 7rem;
    max-width: 100%;
}

.login-messages {
    line-height: 2rem;
}

.login-bsf {
    width: 250px
}


@media screen and (min-width: 600px) {
    .login-background {
        background: fixed url(/public/images/bg-bubbles.png), linear-gradient(45deg, hsl(222, 38%, 49%) 0%, hsl(144, 25%, 42%) 100%);
        background-size: cover, cover;
    }


    .login-box {
        background: linear-gradient(180deg, rgba(255, 255, 255, .65) 0%, rgba(255, 255, 255, 0.8) 23%, rgba(255, 255, 255, 0.8) 70%, rgba(255, 255, 255, 0.6) 100%);
        border-radius: 0px;
        box-shadow: 0px 25px 50px -12px rgba(0, 0, 0, 0.25);
    }


}


</style>